import { render, staticRenderFns } from "./unreadEventsCount.vue?vue&type=template&id=db4440fc"
import script from "./unreadEventsCount.vue?vue&type=script&lang=js"
export * from "./unreadEventsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db4440fc')) {
      api.createRecord('db4440fc', component.options)
    } else {
      api.reload('db4440fc', component.options)
    }
    module.hot.accept("./unreadEventsCount.vue?vue&type=template&id=db4440fc", function () {
      api.rerender('db4440fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/sidebar/unreadEventsCount.vue"
export default component.exports